import React from "react";
import FormularioVentaFacturas from "js/components/FormularioFacturaPorPuntos";

function ProductoFactura(props) {
  return <FormularioVentaFacturas />;
}

export default ProductoFactura;
